import { mapEntityProperties } from '@/utils/mapEntityProperties'
import { LiveMealResponseEntity } from '../../domain/entities/LiveMealResponseEntity'
import type { GetMealStreamsV2ResponseAdmin } from '@/backend/market'
import { LiveMealEntity } from '../../domain/entities/LiveMealEntity'
import { LiveMealModel } from './LiveMealModel'

export class LiveMealStreamV2ResponseModel extends LiveMealResponseEntity {
  nextCursor?: string
  hasNextPage?: boolean

  constructor(dataDto: GetMealStreamsV2ResponseAdmin) {
    super()
    const liveMealModels = dataDto.data?.map((meal) => new LiveMealModel(meal as LiveMealEntity))
    this.nextCursor = dataDto.nextCursor || undefined
    this.hasNextPage = dataDto.hasNextPage || false
    
    // Generic mapEntityProperties might complain about mismatched types if not perfectly aligned
    // So we manually assign what we need or suppress if acceptable, but let's try to be clean.
    // The super class LiveMealResponseEntity expects optional meals array.
    mapEntityProperties<LiveMealResponseEntity>(
      this,
      dataDto as unknown as Partial<Record<keyof LiveMealResponseEntity, unknown>>,
      {
        map: {
          meals: liveMealModels
        }
      }
    )
  }
}
